import type { IFormxRepository } from '../repositories/IFormxRepository.js';

interface Deps { formxRepository: IFormxRepository; }

export function createListFormxValueSummaryUseCase({ formxRepository }: Deps) {
  return async function listFormxValueSummary(formId: string) {
    return formxRepository.listValueSummaryByForm(formId);
  };
}
